import { Card, CardContent, Typography, Box } from "@mui/material";

export default function CourseCard({ course }) {
    return (
        <Card sx={{ mb: 2, borderRadius: 2, boxShadow: 2 }}>
            <CardContent>
                <Typography variant="h6">{course.courseCode} - {course.courseName}</Typography>
                {course.creditHours != null && (
                    <Typography variant="body2" color="textSecondary">
                        Credit Hours: {course.creditHours}
                    </Typography>
                )}
                {course.courseDescription && (
                    <Box mt={1}>
                        <Typography variant="body2">{course.courseDescription}</Typography>
                    </Box>
                )}
            </CardContent>
        </Card>
    );
}